import angular from 'angular';
//This filter gets a number of minutes and formats it to 'hh:mm' format.
angular.module('commonServices').filter('ogm', function() {
  return function(value) {
    if (!value) return;
    if (value.match(/^\+{3}(\d{3})\/(\d{4})\/(\d{5})\+{3}/gm)) return value;
    const stripped = value.replace(/\D+/g, '');
    if (stripped.length !== 12) return value; //Value doesn't have the correct size
    return stripped.replace(/^(\d{3})(\d{4})(\d{5})$/, '+++$1/$2/$3+++');
  };
});
